import { IconProps } from 'interfaces';
import COLOR from 'constants/color';

const Drum = ({
  fill = COLOR.GRAY['900'],
  className = 'w-4 h-4',
  styles
}: IconProps) => {
  return (
    <svg
      className={styles || className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'
    >
      <ellipse
        cx='12'
        cy='12'
        rx='8'
        ry='3'
        stroke={fill}
        strokeWidth='2'
        fill='none'
      />
      <path
        d='M4 12v-2a8 8 0 0 1 16 0v2M4 12v2a8 8 0 0 0 16 0v-2'
        stroke={fill}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <line
        x1='4'
        y1='12'
        x2='4'
        y2='9'
        stroke={fill}
        strokeWidth='2'
        strokeLinecap='round'
      />
      <line
        x1='20'
        y1='12'
        x2='20'
        y2='9'
        stroke={fill}
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default Drum;
